module.exports = __webpack_public_path__ + "img/edge2.aa1ae44e.png";